import React, { useState, useEffect } from 'react';
import { DOCUMENT_MARKUP } from '@Constants/types';
import store from '@Store';
import { executeLabelsBatch, executeLabelsBatch2 } from '@Service/wordApiService';
import { getSkipCount } from '@Utils/commonUtils';

function callAPI() {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(), 10000);
    });
}

let labelSkipTotal = 0;
function useBackgroundService() {
    const [backgroundService, setBackgroundService] = useState(null);

    useEffect(() => {
        const bgService = setInterval(() => {
            // eslint-disable-next-line
            callAPI().then(() => {
                if (labelSkipTotal === 0) {
                    const skip = getSkipCount();
                    labelSkipTotal += skip;
                    const rootReducer = store.getState();
                    const { document } = rootReducer;
                    const {
                        mappedParagraphsLabels,
                        mappedParagraphsLabels2,
                        showMisses,
                        isMarkupCancelling
                    } = document;

                    if (isMarkupCancelling) {
                        return;
                    }

                    // Full Paragraphs replaced with content controls
                    if (mappedParagraphsLabels && mappedParagraphsLabels.length > 0) {
                        const nextBatch = mappedParagraphsLabels.splice(0, 20);
                        executeLabelsBatch(nextBatch, showMisses);

                        // update reducer with the reduced array
                        store.dispatch({
                            type: DOCUMENT_MARKUP.BACKGROUND_PROCESS_LABELS,
                            payload: {
                                mappedParagraphs: mappedParagraphsLabels,
                                mappedParagraphs2: mappedParagraphsLabels2,
                                showMisses
                            }
                        });

                        return;
                    }

                    // replaced jump-to hits with content controls
                    if (mappedParagraphsLabels2 && mappedParagraphsLabels2.length > 0) {
                        const nextBatch = mappedParagraphsLabels2.splice(0, 1);
                        executeLabelsBatch2(nextBatch, showMisses);

                        // update reducer with the reduced array
                        store.dispatch({
                            type: DOCUMENT_MARKUP.BACKGROUND_PROCESS_LABELS,
                            payload: {
                                mappedParagraphs: mappedParagraphsLabels,
                                mappedParagraphs2: mappedParagraphsLabels2,
                                showMisses
                            }
                        });
                    }
                } else {
                    labelSkipTotal = labelSkipTotal - 1;
                }
            });
        }, 1100);

        function cleanup() {
            clearInterval(bgService);
        }

        setBackgroundService(bgService);

        return cleanup;
    }, []);

    return backgroundService;
}

function LabelsProcess() {
    useBackgroundService();

    return <></>;
}

export default LabelsProcess;
